import type { ReactNode } from "react";
import { Title, Subtitle } from "@/components/ui/typography";
import { cn } from "@/components/ui/cn";

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  badge?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export function PageHeader({
  title,
  subtitle,
  badge,
  actions,
  className,
}: PageHeaderProps): React.JSX.Element {
  return (
    <header className={cn("flex flex-wrap items-start justify-between gap-4", className)}>
      <div className="space-y-1">
        <div className="flex flex-wrap items-center gap-3">
          <Title>{title}</Title>
          {badge}
        </div>
        {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
      </div>
      {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
    </header>
  );
}
